import { render } from "./Navmenu.vue?vue&type=template&id=5fc545eb"
import script from "./Navmenu.vue?vue&type=script&lang=js"
export * from "./Navmenu.vue?vue&type=script&lang=js"

import "./Navmenu.vue?vue&type=style&index=0&id=5fc545eb&lang=scss"
import "./Navmenu.vue?vue&type=style&index=1&id=5fc545eb&lang=scss"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__